import { fetchAsyncPipeline } from "./pipelineThunk";
import { createSlice } from "@reduxjs/toolkit";

const pipelineSlice = createSlice({
  name: `pipeline`,
  initialState: {
    items: {
      data: [],
    },
  },
  reducers: {
    setPipeline: (state, { payload }) => {
      return {
        ...state,
        items: {
          ...state.items,
          data: payload,
        },
      };
    },
  },
  extraReducers: {
    [fetchAsyncPipeline.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        items: payload,
      };
    },
  },
});

export default pipelineSlice.reducer;
